/**
 * `payments/recurring-charges/` — Node-only feature, no Django counterpart.
 * See refactor/backend/src/modules/recurringCharges/routes.ts and
 * refactor/docs/PARITY_NOTES.md.
 */
import { apiClient } from '../client';
import { RECURRING_CHARGES } from './paths';
import type { Paginated } from '../types';
import type {
  RecordReadingRequest,
  RecordReadingResponse,
  RecurringCharge,
  RecurringChargeCreateRequest,
  RecurringChargePatchRequest,
} from '../../types/recurringCharge';

export async function listRecurringCharges(params?: {
  page?: number;
  property?: number;
  lease?: number;
  is_active?: boolean;
  charge_basis?: string;
  scope_mode?: string;
}): Promise<Paginated<RecurringCharge>> {
  const response = await apiClient.get<Paginated<RecurringCharge>>(RECURRING_CHARGES, { params });
  return response.data;
}

export async function getRecurringCharge(id: number): Promise<RecurringCharge> {
  const response = await apiClient.get<RecurringCharge>(`${RECURRING_CHARGES}${id}/`);
  return response.data;
}

export async function createRecurringCharge(
  payload: RecurringChargeCreateRequest,
): Promise<RecurringCharge> {
  const response = await apiClient.post<RecurringCharge>(RECURRING_CHARGES, payload);
  return response.data;
}

export async function updateRecurringCharge(
  id: number,
  payload: RecurringChargePatchRequest,
): Promise<RecurringCharge> {
  const response = await apiClient.patch<RecurringCharge>(`${RECURRING_CHARGES}${id}/`, payload);
  return response.data;
}

export async function recordReading(
  id: number,
  payload: RecordReadingRequest,
): Promise<RecordReadingResponse> {
  const response = await apiClient.post<RecordReadingResponse>(
    `${RECURRING_CHARGES}${id}/record_reading/`,
    payload,
  );
  return response.data;
}
